import { getTarget } from '../rpc';

const rpc = getTarget({ target: window.parent });
const SIGNAL_TYPES = {
  USERINPUT: 'user.input',
  LIFECYCLE: 'widget.lifecycle',
  INTERACTION: 'widget.interaction',
  CUSTOM_EVENT: 'widget.custom_event',
  CLICK: 'user.click',
};

const sendSignal = (signal: string, payload: object) => {
  rpc.call('signal', {
    signal,
    payload: {
      message: {
        timestamp: Date.now(),
        ...JSON.parse(JSON.stringify(payload)),
      },
    },
  });
};

const click = (source: string, payload: object) => {
  sendSignal(SIGNAL_TYPES.CLICK, { ...payload, source });
};

const lifecycle = (source: string, payload: object) => {
  sendSignal(SIGNAL_TYPES.LIFECYCLE, { ...payload, source });
};

const interaction = (source: string, payload: object) => {
  sendSignal(SIGNAL_TYPES.INTERACTION, { ...payload, source });
};

const customEvent = (source: string, payload: object) => {
  sendSignal(SIGNAL_TYPES.CUSTOM_EVENT, { ...payload, source });
};

const userInput = (source: string, payload: object) => {
  sendSignal(SIGNAL_TYPES.USERINPUT, {
    ...payload,
    action: 'user_input',
    source,
  });
};

export default {
 click, lifecycle, interaction, userInput, customEvent 
};
